import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    AgentRegistration as AGENT_REGISTRATION,
    GenerateURL as GENERATE_URL,
    CheckUserAgentID as CHECKUSERAGENTID
} from 'Components/Api/PaysprintPPIAPI';
import { useLocation } from 'react-router-dom';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Select as SELECT_STATE } from 'Components/Api/StatesApi';
import usePosition from 'Components/Posistion';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';

const CustomContainer = HOCLoader(Container);

const PaysprintPPIAgentRegistration = () => {
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const { latitude, longitude } = usePosition();
    const ActivePPIName = location?.state?.DMTName;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [stateList, setStateList] = useState([]);

    const [stateDefault, setStateDefault] = useState({
        StateID: 0,
        Name: 'Select State'
    });

    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        Email: '',
        Address: '',
        PanNumber: '',
        PinCode: '',
        State: stateDefault,
        Latitude: latitude,
        Longitude: longitude
    });

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        Email: Yup.string().required(PLEASE_PROVIDE_VALID + 'email'),
        PanNumber: Yup.string().required(PLEASE_PROVIDE_VALID + 'PanNumber'),
        Address: Yup.string().required(PLEASE_PROVIDE_VALID + 'address'),
    });

    const selectStates = async (values) => {
        var request = JSON.stringify(values);
        const response = await SELECT_STATE(request);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
        }

        var data = JSON.parse(response.data);
        setStateList(data);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var request = {
            DMTName: ActivePPIName,
            Name: values.Name,
            Mobile: values.Mobile,
            Email: values.Email,
            Address: values.Address,
            PanNumber: values.PanNumber,
            PinCode: values.PinCode,
            State: values.State.Name,
            Latitude: latitude,
            Longitude: longitude
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);
        var response = await AGENT_REGISTRATION(requestObj);
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);
        await generateUrl(values);
    };

    const CheckPaySpeintAgentID = async () => {
        setResponseMessage('');
        const response = await CHECKUSERAGENTID();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            const data = response.data;
            if (data === 'User not onboarded') {
                setResponseMessage(data);
                history.push('/PS_PPIAgentRegistration');
                return;
            }
            return;
        }
        generateUrl();
    };

    const generateUrl = async () => {
        setLoading(true);
        setIsError(false);
        var response = await GENERATE_URL(); 
        setLoading(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        } 
        var data = JSON.parse(response.data); 
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);
        let param = {
            EncData: data.EncData,
            RedirectURL: data.URL
        };
        history.push({
            pathname: '/PS_PPIRedirectURL',
            state: param,
        });
    };

    useEffect(() => {
        selectStates();
        CheckPaySpeintAgentID();
    }, []);
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                                style={{ justifyContent: 'center' }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Agent Registration
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialTextField
                                                        label="Name"
                                                        name="Name"
                                                        type="Name"
                                                        placeholder="Name"
                                                    />

                                                </Grid>
                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="Mobile"
                                                        length={10}
                                                        placeholder="Mobile"
                                                    />

                                                </Grid>
                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialTextField
                                                        label="Email"
                                                        name="Email"
                                                        type="Email"
                                                        placeholder="Email"
                                                    />

                                                </Grid>

                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialTextField
                                                        label="Pan Card"
                                                        name="PanNumber"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Pan Card"
                                                    />

                                                </Grid>

                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialTextField
                                                        label="Address"
                                                        name="Address"
                                                        type="Address"
                                                        placeholder="Address"
                                                    />

                                                </Grid>

                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialNumberField
                                                        label="PinCode"
                                                        name="PinCode"
                                                        type="PinCode"
                                                        length={6}
                                                        placeholder="PinCode"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            stateDefault
                                                        }
                                                        FieldName="State"
                                                        SubFieldName="StateID"
                                                        name="State"
                                                        options={stateList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Name}
                                                        textFieldProps={{
                                                            label:
                                                                'Select State'
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setStateDefault({
                                                                StateID:
                                                                    value.StateID,
                                                                Name: value.Name
                                                            });
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div className={classes.SubmitWrapper}>
                                                <Button
                                                    type="submit"
                                                    title="Submit"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Submit
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer >
    );
};
export default PaysprintPPIAgentRegistration;
